module.exports = __webpack_public_path__ + "img/youth-reader.5e3bdfd8.png";